import normalize from "app/utils/normalize";

export const cardVariants = {
  defaults: {
    borderRadius: 8,
  },
  actionCard: {
    flex: 1,
    height: "100%",
    zIndex: 1,
    borderRadius: normalize(8),
    elevation: 0,
  },
  cardDiff: {
    borderColor: "neutral.100",
    backgroundColor: "neutral.white",
    shadowColor: { phone: "neutral.100", smallWeb: "transparent" },
    shadowOpacity: { phone: 0.25, smallWeb: 0 },
    shadowRadius: 12,
    shadowOffset: {
      phone: {
        height: 4,
        width: 0,
      },
      smallWeb: {
        height: 0,
        width: 0,
      },
    },
    paddingHorizontal: { phone: "xm", smallWeb: "null" },
    paddingVertical: { phone: "sm", smallWeb: "null" },
    elevation: 1,
  },
  cardAllowNotification: {
    borderColor: "neutral.300",
    backgroundColor: "neutral.75",
    borderWidth: 1,
    shadowColor: "neutral.400",
    shadowOpacity: 0.25,
    shadowRadius: 1,
    shadowOffset: {
      height: 4,
      width: 0,
    },
    padding: "null",
  },
  cardModal: {
    width: "90%",
    backgroundColor: "neutral.white",
    paddingHorizontal: "m",
    paddingVertical: "s",
    alignSelf: "center",
  },
  cardCampaignModal: {
    borderColor: "transparent",
    backgroundColor: "neutral.white",
    shadowColor: "neutral.400",
    shadowOpacity: 0.25,
    shadowOffset: {
      height: 4,
      width: 0,
    },
    elevation: 1,
    padding: {
      phone: "xm",
      web: "l",
    },
  },
  informationCard: {
    width: "100%",
    borderRadius: normalize(8),
    borderColor: {
      phone: "neutral.100",
      smallWeb: "transparent",
    },
    borderWidth: {
      phone: 1,
      smallWeb: 0,
    },
    backgroundColor: "neutral.white",
    paddingHorizontal: {
      phone: "sm",
      smallWeb: "xm",
    },
    paddingVertical: {
      phone: "sm",
      smallWeb: "sm",
    },
  },
  timelineCard: {
    borderRadius: normalize(8),
    alignItems: "center",
    paddingLeft: {
      phone: "sm",
    },
    paddingRight: {
      phone: "sm",
    },
    paddingVertical: {
      phone: "sm",
    },
  },
  feedbackCard: {
    borderRadius: normalize(8),
    borderWidth: 1,
    borderColor: "neutral.100",
    padding: "sm",
  },
};
